const momentDate = (date, dateRange) => {
    if (!date || !dateRange) return null;
    const moment = require('moment');
    const selectedDate = moment(date);
    switch (dateRange) {
        case 'oneMonth':
            return selectedDate.clone().subtract(1, 'months').format('YYYY-MM-DD');
        case 'threeMonth':
            return selectedDate.clone().subtract(3, 'months').format('YYYY-MM-DD');
        case 'sixMonth':
            return selectedDate.clone().subtract(6, 'months').format('YYYY-MM-DD');
        default:
            return null;
    }
};
export default momentDate;
